import {config} from '../config';

export default {
    getIsLedEnabled: () => config.data.deviceFeatures.isLedEnabled,
    getIsVibrationEnabled: () => config.data.deviceFeatures.isVibrationEnabled,
    getIsSelfCleaningEnabled: () => config.data.deviceFeatures.isSelfCleaningEnabled,
    getIsDeviceAlarmEnabled: () => config.data.deviceFeatures.isDeviceAlarmEnabled,
    getIsParentProtectionEnabled: () => config.data.deviceFeatures.isParentProtectionEnabled,
    getIsVapeCloudSizeEnabled: () => config.data.deviceFeatures.isVapeCloudSizeEnabled,
    getIsResponsiveDrawProfileEnabled: () => config.data.deviceFeatures.isResponsiveDrawProfileEnabled,
    getIsAutoStartEnabled: () => config.data.deviceFeatures.isAutoStartEnabled,
    getIsGestureEnabled: () => config.data.deviceFeatures.isGestureEnabled,
    getIsSessionProfilingEnabled: () => config.data.deviceFeatures.isSessionProfilingEnabled,
    getIsDeviceResetFeatureEnabled: () => config.data.deviceFeatures.isDeviceResetEnabled,
    getIsAemFlexBatteryEnabled: () => config.data.deviceFeatures.isAemFlexBatteryEnabled,
    getIsFlexPuffEnabled: () => config.data.deviceFeatures.isFlexPuffEnabled,
    getIsManualUpdateDeviceInfoEnabled: (deviceType) =>
        config.data.deviceFeatures.manualUpdateDeviceInfoEnabled?.includes(deviceType),
    getIsRemainingSticksEnabled: (deviceType) =>
        config.data.deviceFeatures.remainingSticksEnabled?.includes(deviceType),
};
